declare var BASE_URL:string;
declare var STATIC_BASE_URL:string;

import '../styles/products.scss';
import '../styles/frames.scss';

import { h, Component } from 'preact';

export default class Chatbotassistant extends Component<any, any> {

    constructor() {
        super();
    }
  
    private showYT (e) {
      e.preventDefault();
      this.props.ytCB('LK89l6PoUFo');
    }

    public render (props, state): any {
      
      const calltoaction = <p class="center calltoaction"><a href="#" onClick={ this.showYT.bind(this) } class="butt huge">watch demo</a> <a href="./register" class="butt huge">Try it free</a></p>;

        return <div id="chatbotassistant" class="product">
          <div class="mainWrp">
            <section class="body center">
              <h1>Chatbot Assistant</h1>
              <h2 class="content">
                Our Graphical Bot Configurator “Querlo” has given birth to more than 1,000 conversational AI solutions with responses completely personalized for you and your customers.
              </h2>
              { calltoaction }
            </section>
          </div>
          <div class="mainWrp frameWrp">
            <div class="col">
              <div class="frame iphonex">
                <img class="frameImg" src={STATIC_BASE_URL + 'images/public/frame_iphone.png'} alt="Chatbot Assistant" />
                <div class="inframeWrp">
                  <img class="inframe" src={ STATIC_BASE_URL + 'images/public/products-chatbotassistant-detail.png'} alt="Chatbot Assistant" />
                </div>
              </div>
            </div>
            <div class="col padLeft">
              <h2>
                The Chatbot Assistant will transform your business and brand
              </h2>
              <p>
                Our chatbot assistant will represent you as a virtual self. It is a powerful tool to build your audience as an influencer, entrepreneur or just simply want to interact with colleagues to get to know more about you.<br />
                You can share the type of stories, information and content you want. Soon, your chatbot assistant will be able to organize your daily activities, schedule meetings and calls.</p>
            </div>
            <br style="clear:both" />
          </div>
          
          <section class="full grey">
              <p>
                Messaging is one of the most used platforms in our daily and business life. It is important to interact with your audience and continue to target more for your business or brand growth.
              </p>
              <p>
                With the rise of AI, you can explore the advantages of NLU and machine learning to build a smarter chatbot. ​
                Having a chatbot assitant represents an opportunity for business and personal branding to communicate and engage your users through a messaging platform. ​
              </p>
          </section>
          <section>
            <blockquote>
              According to BridghtEdge, the next big marketing trend is seen as being consumer personalization (29%), followed by AI (26%).
              <span>BridghtEdge</span>
            </blockquote>
          </section>
  
          <section class="features center cols full">
            <div class="mainWrp">
              <h2>Benefits</h2>
              <div class="col">
                <div class="col first">
                  <h3><i class="fa fa-users"></i> Reaching new audience</h3>
                  <p>
                    Reach new audience in your specfic industry by being continuosly active on this platform.
                  </p>
                </div>
                <div class="col">
                  <h3><i class="fa fa-clock"></i> Save time</h3>
                  <p>
                    Save time from repeating the same story and information. Let the chatbot assistant provide fast and automated answers to most questions, while you can sit back and relax.​
                  </p>
                </div>
              </div>
              <div class="col">
                <div class="col">
                  <h3><i class="fa fa-grin-hearts"></i> A deeper understanding of your audience</h3>
                  <p>
                    Receive detailed, actionable records of your audience conversation, understand customer behavior to improve your product or services, as well as target marketing focus.​
                  </p>
                </div>
                <div class="col">
                  <h3><i class="fa fa-undo-alt"></i> 24 / 7</h3>
                  <p>
                    Offer full hour support when users have questions around the clock. Having a 24/7 service has a positive impact on your customer satisfaction. ​
                  </p>
                </div>
              </div>
            </div>
          </section>
  
          <section class="features full center cols grey">
            <h2>Features</h2>
            <div class="mainWrp">
              <div class="col">
                <div class="col first">
                  <h3><i class="fa fa-swatchbook"></i> Highly Personalized</h3>
                  <p>
                    Your chatbot works for you personally, and therefore can be 100% tailored according to your preference, including content and visual. ​
                  </p>
                </div>
                <div class="col">
                  <h3><i class="fa fa-vial"></i> Simple to build</h3>
                  <p>
                    Upload your favorite picture and share your personal stories – you can build this chatbot assistant in a few minutes!​
                  </p>
                </div>
              </div>
              <div class="col">
                <div class="col">
                  <h3><i class="fa fa-laptop-code"></i> Easy posting</h3>
                  <p>
                    You can easily post your chatbot assistant anywhere with the unique URL. You can also insert it as an iframe or pop-up into your website.
                  </p>
                </div>
                <div class="col">
                  <h3><i class="fa fa-chart-bar"></i> Analytics</h3>
                  <p>
                    The analytics dashboard will share insights from all conversations engaged with your audience.
                  </p>
                </div>
              </div>
            </div>
            <div class="mainWrp">
              <div class="col allalone">
                <div class="col">
                  <h3><i class="fa fa-tv"></i> Media rich</h3>
                  <p>
                    You can attach various media into the chatbot – images, GIFs, video, etc.​
                  </p>
                </div>
                <div class="col">
                  <h3><i class="fa fa-puzzle-piece"></i> Add-ons</h3>
                  <p>
                    There are various add-ons you can use to upgrade and make your assistant more intelligent and powerful.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </div>
    }
}


// WEBPACK FOOTER //
// ./ts/Chatbotassistant.tsx